














import Vue from 'vue'
import { createComponent, onMounted, reactive, ref } from '@vue/composition-api'

export default createComponent({
    components: {},
    props: {
        names: {
            type: String,
            default: '',
        },
    },
    setup(props, setupContext) {
        return {}
    },
})
